import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "FOLGEBREV";

export function getFolgebrevWithParams(params) {
  return axiosUtils.GetAllWithParams(api.GET_FOLGEBREV_URL, params, actionType);
}
